import { call, takeLatest, put } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import {
  INITIATE_VIEW_FAMILY_DATA,
  SET_FAMILY_SEARCH_QUERY,
  SET_VIEW_FAMILY_DATA,
  SET_VIEW_FAMILY_DATA_FAIL,
} from "../../actionTypes/dashboard";
import Family from "../../../services/api/Family";

// update search query
const updateSearchQuery = (payload) => ({
  type: SET_FAMILY_SEARCH_QUERY,
  payload,
});

// onSuccess handler for family data api
const onFamilyDataSuccess = (payload) => ({
  type: SET_VIEW_FAMILY_DATA,
  payload,
});

// onFail handler for family data api
const onFamilyDataFail = (payload) => ({
  type: SET_VIEW_FAMILY_DATA_FAIL,
  payload,
});

/**
 * This function handles the family data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getFamilyData(action) {
  try {
    const { data } = yield call(Family.searchFamilyDetails, action.payload);
    yield put(
      onFamilyDataSuccess({
        data: data.content,
        paginationInfo: {
          currentPage: Number(data.number),
          totalPages: Number(data.totalPages),
          totalElements: Number(data.totalElements),
          pageSize: Number(data.size),
        },
      })
    );
    yield put(updateSearchQuery(action.payload.name));
  } catch (error) {
    yield put(onFamilyDataFail(error));
    Sentry.captureException(error);
  }
}

/**
 * Watcher saga for family
 */
function* watchFamilySaga() {
  yield takeLatest(INITIATE_VIEW_FAMILY_DATA, getFamilyData);
}
export default watchFamilySaga;
